module.exports = __webpack_public_path__ + "static/media/asp.net_.8f075eb3.jpg";